"use client";

import { useSyncExternalStore } from "react";

// What the site header needs from the Mae page to become Mae's header on a
// phone: what her last real check found (mae-check-status; never the page
// load), the New chat action, the action that opens
// the page's drawer, and whether the drawer holds something that needs the
// buyer. The page publishes these while it is mounted; the nav reads them. A
// module-level store rather than a context so the layout needs no provider
// and nothing re-renders but the nav.

export type MaeHeaderState = {
  // The check's short line, or null when there is no check to speak of.
  checkLabel: string | null;
  // Amber: the check is stale, failed, or late.
  checkWarning: boolean;
  onNewChat: (() => void) | null;
  onOpenMenu: (() => void) | null;
  menuSignal: boolean;
};

const EMPTY: MaeHeaderState = { checkLabel: null, checkWarning: false, onNewChat: null, onOpenMenu: null, menuSignal: false };

let state: MaeHeaderState = EMPTY;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getMaeHeader(): MaeHeaderState {
  return state;
}

export function setMaeHeader(next: MaeHeaderState) {
  if (
    next.checkLabel === state.checkLabel
    && next.checkWarning === state.checkWarning
    && next.onNewChat === state.onNewChat
    && next.onOpenMenu === state.onOpenMenu
    && next.menuSignal === state.menuSignal
  ) return;
  state = next;
  listeners.forEach(listener => listener());
}

export function clearMaeHeader() {
  setMaeHeader(EMPTY);
}

export function useMaeHeader(): MaeHeaderState {
  return useSyncExternalStore(subscribe, getMaeHeader, () => EMPTY);
}
